export default "__VITE_ASSET__DKsoMXL0__"